import { render } from "./index.vue?vue&type=template&id=c0e01f52&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=c0e01f52&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c0e01f52"

export default script